import { render, staticRenderFns } from "./Posters.vue?vue&type=template&id=0b6acbf9&scoped=true"
import script from "./Posters.vue?vue&type=script&lang=js"
export * from "./Posters.vue?vue&type=script&lang=js"
import style0 from "./Posters.vue?vue&type=style&index=0&id=0b6acbf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6acbf9",
  null
  
)

export default component.exports